import { Card, CardHeader, makeStyles, SkeletonItem, Text, tokens } from '@fluentui/react-components';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { IAppValidationItem } from '../abstractions/IAppValidation';
import { ValidationStatus as Status } from '../abstractions/EAppValidation';

const useStyles = makeStyles({
  card: {
    flex: '1',
    minWidth: "160px",
    maxWidth: "380px",
    height: "150px",
    boxSizing: "border-box",
    borderRadius: "4px"
  },
});

export const ValidationStatus: React.FC<{
  currentValidation: IAppValidationItem | null;
}> = ({ currentValidation }) => {
  const classes = useStyles();
  const intl = useIntl();

  const header = intl.formatMessage({
    defaultMessage: "Status",
    description: "Validation Status Title"
  });

  const progress = intl.formatMessage({
    defaultMessage: "Validation in progress",
    description: "Validation in progress"
  });

  const complete = intl.formatMessage({
    defaultMessage: "Validation completed",
    description: "Validation completed"
  });

  if (!currentValidation) {
    return <CardSkeleton />
  }

  const statusText = currentValidation?.status === Status.Completed ? complete : progress;
  const completed = currentValidation?.status === Status.Completed ? true : false;
  const lastUpdated = currentValidation?.updatedAt
    ? intl.formatDate(currentValidation.updatedAt, {
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'
    })
    : intl.formatMessage({ defaultMessage: "N/A", description: "No update date available" });

  return (
    <Card className={classes.card}>
      <CardHeader
        header={<Text weight="semibold">{header}</Text>}
      />
      <Text>
        {statusText}
      </Text>
      {
        completed
          ? <div style={{ width: "100%", height: "6px", background: tokens.colorBrandForeground1 }}></div>
          : <SkeletonItem style={{ width: "100%", height: "6px" }} />
      }
      <FormattedMessage
        defaultMessage="Last Updated: {lastUpdated}"
        description="Last updated datetime"
        values={{ lastUpdated: lastUpdated }}
      />
    </Card>
  );
}

const CardSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardHeader
        header={<SkeletonItem style={{ width: "30%" }} />}
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <SkeletonItem style={{ width: "80%" }} />
        <SkeletonItem style={{ width: "50%" }} />
        <SkeletonItem style={{ width: "30%" }} />
      </div>
    </Card>
  )
}